import React from 'react'
import { Box, Stack, Heading, Flex, Text, Tag, Image, useColorMode, Grid, Skeleton } from '@chakra-ui/react'
import ImageGallery from 'react-image-gallery'

export const ProjectPhysicalItem = ({ title, desc, images }) => {
  const { colorMode } = useColorMode()

  return (
    <Stack marginBottom={5}>
      <Heading as="h2" size={{ base: 'lg', md: 'xl' }} color={`mode.${colorMode}.career.text`}>
        {title}
      </Heading>
      <Grid
        gridTemplateColumns={['1fr', '1fr', '1fr 1fr', '1fr 1fr']}
        borderColor={`mode.${colorMode}.border`}
        rounded="md"
      >
        <Box w="100%">
          <Stack mt={2}>
            <Box fontWeight="semibold" lineHeight="short" color={`mode.${colorMode}.subtext`}>
              {desc}
            </Box>
          </Stack>
        </Box>
        <Flex w="100%" h="100%" alignItems="center" ml={{ sm: '0', md: '4' }} pt={{ sm: '4', md: '0' }}>
          <Box w="100%" className="physical-project-gallery">
            <ImageGallery items={images} showBullets showPlayButton={false} />
          </Box>
        </Flex>
      </Grid>
    </Stack>
  )
}
